module.exports = __webpack_public_path__ + "fonts/NanumSquareR.b0dcfde6.ttf";